import React from 'react'
import PropTypes from 'prop-types'

import FlatButton from 'material-ui/FlatButton'
import Popover from 'material-ui/Popover'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import MediaQuery from 'react-responsive'

import FiboBetaLogo from '../common/FiboBeta'

const ModeItem = ({ id, text, selected, onClick }) => {
  return (
    <MenuItem
      key={id}
      primaryText={text}
      onClick={onClick}
      style={{ color: selected ? '#4d6f7f' : '#4a4a4a', fontWeight: 400 }} />
  )
}

ModeItem.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}

export default class DisplayModeSelector extends React.Component {

  static propTypes = {
    viewMode: PropTypes.string,
    onViewModeChanged: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      openModeSelector: false
    }
  }

  handleDisplayModeOptionsClicked = () => {
    this.setState({ openModeSelector: true })
  }

  handleDisplayModeOptionSelected = mode => {
    this.setState({ openModeSelector: false })
    this.props.onViewModeChanged(mode)
  }

  render() {
    return (
      <div>
        <Popover
          open={this.state.openModeSelector}
          anchorEl={this.modeButton}
          anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'left', vertical: 'top'}}
          onRequestClose={() => this.setState({ openModeSelector: false })}>
          <Menu>
            <ModeItem id='week'
              text='Week'
              selected={this.props.viewMode === 'week'}
              onClick={() => this.handleDisplayModeOptionSelected('week')} />
            <ModeItem id='day'
              text='Day'
              selected={this.props.viewMode === 'day'}
              onClick={() => this.handleDisplayModeOptionSelected('day')} />
            <ModeItem id='map'
              text='Map'
              selected={this.props.viewMode === 'map'}
              onClick={() => this.handleDisplayModeOptionSelected('map')} />
          </Menu>
        </Popover>
        <MediaQuery maxWidth={1172}>
          <div ref={modeButton => this.modeButton = modeButton}>
            <FlatButton
              style={{ minWidth: 36, width: 36, height: 36, border: 'none' }}
              onTouchTap={this.handleDisplayModeOptionsClicked}>
              <i className='material-icons' style={{ fontSize: 36, color: '#4d6f7f' }}>toc</i>
            </FlatButton>
          </div>
        </MediaQuery>
        <MediaQuery minWidth={1173}>
          <div>
            <FlatButton
              style={{border: '1px solid #e2e2e2'}}
              labelStyle={{ color: '#4d6f7f', fontWeight: 400 }}
              label='Week'
              backgroundColor={(this.props.viewMode === 'week' ? 'white' : 'transparent')}
              onTouchTap={() => this.props.onViewModeChanged('week')}/>
            <FlatButton
              style={{border: '1px solid #e2e2e2', marginLeft: 4 }}
              labelStyle={{ color: '#4d6f7f', fontWeight: 400 }}
              label='Day'
              backgroundColor={(this.props.viewMode === 'day' ? 'white' : 'transparent')}
              onTouchTap={() => this.props.onViewModeChanged('day')}/>
            <FlatButton
              style={{ border: '1px solid #e2e2e2', marginLeft: 4 }}
              labelStyle={{ color: '#4d6f7f', fontWeight: 400 }}
              backgroundColor={(this.props.viewMode === 'map' ? 'white' : 'transparent')}
              onTouchTap={() => this.props.onViewModeChanged('map')}>
              <FiboBetaLogo
                labelStyle={{ fontSize: 14, color: '#4d6f7f', fontWeight: 400 }}
                label={'Map'}/>
            </FlatButton>
          </div>
        </MediaQuery>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/schedule/DisplayModeSelector.js